export function projectImageCrop(width, height, { aspect = "original", zoom = 1, x = 50, y = 50, size = 1024 } = {}) {
  const ratio = aspect === "original" ? width / height : Number(aspect);
  const cropWidth = Math.min(width, height * ratio) / zoom;
  const cropHeight = cropWidth / ratio;
  const scale = Math.min(1, size / Math.max(cropWidth, cropHeight));
  return { sx: (width - cropWidth) * x / 100, sy: (height - cropHeight) * y / 100,
    sw: cropWidth, sh: cropHeight, width: Math.max(1, Math.round(cropWidth * scale)), height: Math.max(1, Math.round(cropHeight * scale)) };
}
